module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAAXNSR0IArs4c6QAAAVpJREFUSEvV1y9WAzEQBvDvuwOHQSIQFBQCDBZOAKKcAAScACwGBIo/AlHJYXqH4YWX7Msuk+xMdnmFyjaZX2aSSXeJDX0YXBHZAbANYAvAB8n3OdcjInsAdgGsAXySXCX4DsBphh2TfJoDF5EjAI9ZrHuSZwm+AXA+gCbjChqIW5IXCQ6leFMybMYLaCAWYSu/4bjPw5Kkn9x4Be1idfBcuAUNVg+eiltRFW7FPWgR9uJetApb8RZ0FB7D47HPLwdzJ/w4XNptVclKG25qPxM8knmOm1BTqfOoI5mb0f8BG/fZnLVpj42o+USbSl3r019rJ8vlYBmj9Vyx1J6AnrFpESrcEsg752/8LXpX7bxee6222UcfEdkH8KJkYL4QhnMr1Tsg+Vp6rg5xmtG0iALee65eArjKVj0ZreCXJK/zV5iTOPg5lEI7OK3fxa08jPMfuleY1oBT5n0B0tDzH+2glTsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/close1.png
// module id = /cWH
// module chunks = 4